import React from 'react';

import View from './view';
import {useSelector} from 'react-redux';
import {holderProfileSelector, profileUscSelector} from '../../../redux/selectors/profile';
import {UscType} from '../../models/profile/uscType';
import {Props} from './model';
import {CardStatus} from '../../../types/enums/cardStatus';

export const CardInfo = (props: Props) => {
  const {
    dateIssue = '',
    cardStatusId,
    uscType = 0,
    campusParticipant = false,
  } = useSelector(holderProfileSelector()) || {};
  const usc = useSelector(profileUscSelector());
  const holderProfile = useSelector(holderProfileSelector());
  const uscIsBlocked = cardStatusId === CardStatus.Blocked || Boolean(holderProfile?.uscIsBlocked);
  return (
    <View
      card={usc}
      dateUntil={dateIssue}
      uscIsBlocked={uscIsBlocked}
      isFinancial={uscType === UscType.Financial}
      isCampusParticipant={campusParticipant}
      {...props}
    />
  );
};
